import { JobSearchForm } from "@/components/job-search-form"
import { getSavedSearchById } from "@/lib/saved-searches-data"
import MainAppRoute from "@/rootRoutes/MainApp"
import { createRoute } from "@tanstack/react-router"


const SearchPageRoute = createRoute({
  getParentRoute: () => MainAppRoute,
  path: "/searches/$searchId",
  component: ()=><SearchPage />,
})
export default SearchPageRoute


function SearchPage() {
  const params = SearchPageRoute.useParams()
  const savedSearch = getSavedSearchById(params.searchId)


  return (
    <div className="container mx-auto py-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Resume Search: {savedSearch?.name}</h1>
        <p className="text-muted-foreground">Continue your search with pre-configured filters</p>
      </div>

      <JobSearchForm initialFilters={savedSearch?.filters} />
    </div>
  )
}
